module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("eHr9b"))).then(() => parcelRequire('1iHdE'));